// extracted by mini-css-extract-plugin
export default {"component":"ClientCommunicationsRoutes_component__5tYdp"};